import React from "react";
//css
import './CookiePolicy.css';

const RefundPrivacy = () => {
  
  return (
    <div className="policy_section">
      <div className="policy_left">
        <p>CANCELLATION AND REFUND POLICY</p>
        <span>Dated: 4th September’ 2021</span>
      </div>
      <div className="policy_right">
        <span>Student cancellation: </span>
        <p>
        All course Fees are refundable within fifteen (15) days of your joining the course, provided you are cancelling or terminating with the Services or Neurolingua Content within these fifteen (15) days.
        Upon termination, cancellation or discontinuation of your course for any reason, after first fifteen (15) days, the Fees will not be refunded for any used time on a subscription. To extent permissible by law, refunds (if any) are at our discretion and only in the form of credit for our Services. Any outstanding balance on your account becomes immediately due and payable upon termination of these Terms of Service for any reason.
        <br/><br/>All purchases on Neurolingua are final and cannot be refunded to the original form of payment. Purchased classes can be cancelled and refunded as Neurolingua credit. This credit can be reactivated only once and expires after every six (6) months, however, you can reactivate these credits by requesting us at support@neurolingua.in within six (6) months. Any activity after the expiry of the six (6) month period will not be entertained.
        Any used credit in your user account expires after six (6) months of inactivity.<br/>
        <br/>If you have reason to believe that you have been charged in error, please contact us at support@neurolingua.in explaining the detail about the same. Any such compliant shall be made within thirty (30) days of occurrence of such error.
        Transfer of purchased sessions from one tutor to the other:<br/>
        <br/>If you no longer wish to learn from a particular tutor, but have purchased the sessions for that tutor, which has been scheduled or unscheduled in your dashboard, you can at your discretion cancel such session and request for refund of your Neurolingua credit. These Neurolingua credit will be refunded in your user account and can be used to purchase another session with any tutor of your choice.<br/>
        <br/>Note:
        <br/>If your session is scheduled for less than 12 hours, you will be refunded with 50% credit of that session’s cost.
        <br/>If your session is scheduled for more than 12 hours, you will be refunded with 100% credit of that session’s cost.

        </p>
        <p>
          Students using the NeuroLingua platform are advised not to cancel
          classes that are scheduled. In case of cancellations due to
          unavoidable reasons, students are entitled to receive FULL refund if
          such cancellation is made 24 (or more) hours prior to the time of
          commencement of the scheduled class.
        </p>
        <p>
          Students are eligible for 50% refund for cancellation between 24-12
          hours from the time of commencement of the scheduled class and NO
          refund for cancellation made 4 (or less) hours prior to the time of
          commencement of the scheduled class.
        </p>
        <p>
          In case of cancellations, students are instructed to intimate the
          respective teacher, regarding the cancellation, prior to cancelling
          the session on the platform. (developer, pop-up message)
        </p>
        <p>
          All refunds will be issued in 24 hours as classes that can be
          rescheduled, which students can attend, with any teacher of their
          choosing.
        </p>
        <p>
          If a student chooses not to reschedule a class with any teacher, and
          is insistent on receiving a cash refund, the said refund is issued
          within 60 business days.
        </p>
        <p>
          <i>Platform fee</i> is non-refundable.{" "}
        </p>
        <span>Teacher cancellation: </span>
        <p>
          Teachers are strictly instructed to intimate students in the event of
          a cancellation. All classes cancelled by the teacher drops to the
          student’s main page under classes that can be rebooked/rescheduled.
          Teachers are advised to avoid cancellation of classes to best of their
          abilities.
        </p>
        <span>Bulk cancellation: </span>
        <p>
          If a student purchases classes in bulk from a particular teacher, and
          decides to cancel remaining classes after availing one or more
          sessions, the following rules are followed as applicable:
        </p>
        <p>a.If students wish to take an extended from their course:</p>
        <p>
          Any discount applied for bulk purchase is calculated and reduced from
          the total. The refund is issued within 60 business days and ONLY “
          <i>class fee</i>” is refunded. “<i>Platform fee</i>” is NOT refunded.
        </p>
        <p>b.If students decide to change teachers:</p>
        <p>
          The number of hours remaining is calculated and the proportionate fee
          is refunded as “wallet coins”. Those “<i>wallet coins</i>” can be used
          as a means of discount when students book classes with other teachers.
          In the payment page, a 50% “<i>platform fee</i>” discount will be
          issued when purchasing with only wallet coins.{" "}
        </p>
        <p>
          c.If sessions are “<i>double purchased</i>”:
        </p>
        <p>
          Upon cancellation, “<i>class fee</i>” will be refunded within 7
          business days. “<i>Platform fee</i>” is not refunded.{" "}
        </p>
        <span>Refund Policy: </span>
        <p>
          If a student desires to leave the platform and wants a refund of their
          all purchases; the refund is issued within 90 business days. “
          <i>Platform fee</i>” is non-refundable.{" "}
        </p>
        <p>For any other query feel free to contact us at <a href="mailto:support@neurolingua.in">support@neurolingua.in</a> we will be more than happy to help you.</p>
      </div>
    </div>
  );
};

export default RefundPrivacy;
